import React from "react";

const RenderArchiveLabel = ({ revisionToArchive }) => {
  if (!revisionToArchive) return null;

  return (
    <span style={{ color: "#0D6EFD", fontWeight: "normal" }}>
      {` (Released Revision ${revisionToArchive.rev} with ${revisionToArchive.task_count} open tasks will be Archived)`}
    </span>
  );
};

export default RenderArchiveLabel;
